import {colorVariableMap, lightColors} from './colorTokens'

const toCssVar = (variable) => `var(${variable})`

const colors = Object.entries(colorVariableMap).reduce((acc, [key, variable]) => {
    acc[key] = toCssVar(variable)
    return acc
}, {})

const getColorValue = (key) => {
    const variable = colorVariableMap[key]
    if (!variable) {
        return lightColors[key]
    }
    if (typeof window === 'undefined') {
        return lightColors[key]
    }
    const value = getComputedStyle(document.documentElement).getPropertyValue(variable)
    return value?.trim() || lightColors[key]
}

export {getColorValue}
export default colors
